import SiteHeader from './SiteHeaderDesktop';
import SiteHeaderContainer from '../SiteHeader.container';
export default SiteHeaderContainer(SiteHeader);
//# sourceMappingURL=index.js.map